import React from "react";

const imgs = [
  "https://images.unsplash.com/photo-1574585046455-827418063fc1?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1611273426858-450e7620370f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1696960741206-63a41bb798ad?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://customer-assets.emergentagent.com/job_versacorp-solutions/artifacts/4cnkxmed_photo-1716643863806-989dd76ae093.jpg",
  "https://images.unsplash.com/photo-1615485736894-a2d2e6d4cd9a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1764086172484-7f009f0e9169?crop=entropy&cs=srgb&fm=jpg&q=85",
];

const captions = [
  "Paper cup production line",
  "Paper roll storage",
  "Food packaging containers",
  "Manufacturing floor",
  "Custom printed cups",
  "Eco-friendly packaging",
];

export const Gallery = () => {
  return (
    <section data-testid="gallery-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
              Inside VersaCorp
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-neutral-900">
              Plant, process, products.
            </h2>
          </div>
          <p className="text-neutral-600 max-w-md">
            A glimpse into our facility, manufacturing process, and the finished products that ship across India.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-3">
          {imgs.map((src, i) => (
            <figure
              key={src}
              data-testid={`gallery-img-${i}`}
              className={`group relative rounded-2xl overflow-hidden border border-neutral-200 ${
                i === 0 ? "md:row-span-2 md:col-span-1 aspect-[3/5] md:aspect-auto" : "aspect-[4/3]"
              }`}
            >
              <img src={src} alt={captions[i]} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <figcaption className="absolute left-3 bottom-3 right-3 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                {captions[i]}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
